import { Pipe, PipeTransform } from '@angular/core';
import { AppointmentStatus } from '@services';

@Pipe({
    name: 'appointmentStatus',
    standalone: true,
})
export class AppointmentStatusPipe implements PipeTransform {
    transform(value: AppointmentStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case AppointmentStatus.UnderReview: return 'Under Review';
            case AppointmentStatus.CheckedIn: return 'Checked In';
            case AppointmentStatus.ShuntMovePending: return 'Shunt Move Pending';
            case AppointmentStatus.ReadyToUnload: return 'Ready To Unload';
            case AppointmentStatus.NoShow: return 'No Show';
            case AppointmentStatus.TagsAsnPgiRequired: return 'Tags/ASN/PGI Required';
            case AppointmentStatus.OutboundRefused: return 'Outbound Refused';
            default:
                return value;
        }
    }
}